/* global sortPriceAsc */
/* global sortPriceDesc */
/* global sortScoreAsc */
/* global sortScoreDesc */
/* global activeFiltersTranslation */

import TCAIFilters from "./filters";

const TCAISort = {

    initialization: function () {
        this.sortProducts();
    },

    sortProducts: function () {
        const sortSelect = document.querySelector('.tcai_sort_select');
        const listSelectedFilters = document.querySelector('[class^="tcai_selected-filters"]');

        if (!sortSelect || !listSelectedFilters) {
            return
        }

        sortSelect.addEventListener('change', function () {
            let typeSort = this.value;

            const newSelectedFilter = document.createElement('div');
            newSelectedFilter.classList.add('selected-filter');
            newSelectedFilter.setAttribute('data-name', typeSort);
            newSelectedFilter.setAttribute('data-type', 'Sorting');

            switch (typeSort) {
                case 'price_asc':
                    newSelectedFilter.innerHTML = sortPriceAsc + ' <span class="selected-filter-close">x</span>';
                    break;
                case 'price_desc':
                    newSelectedFilter.innerHTML = sortPriceDesc + ' <span class="selected-filter-close">x</span>';
                    break;
                case 'score_asc':
                    newSelectedFilter.innerHTML = sortScoreAsc + ' <span class="selected-filter-close">x</span>';
                    break;
                case 'score_desc':
                    newSelectedFilter.innerHTML = sortScoreDesc + ' <span class="selected-filter-close">x</span>';
                    break;
            }

            if (listSelectedFilters.querySelectorAll('div').length === 0) {
                const selectedFilterText = document.createElement('div');
                selectedFilterText.classList.add('selected-filter-text');
                selectedFilterText.innerText = activeFiltersTranslation;
                listSelectedFilters.appendChild(selectedFilterText);

                listSelectedFilters.classList.remove('tcai_selected-filters');
                listSelectedFilters.classList.add('tcai_selected-filters-show');
            }

            if (listSelectedFilters.querySelectorAll('.selected-filter[data-type="Sorting"]').length > 0) {
                listSelectedFilters.querySelectorAll('.selected-filter[data-type="Sorting"]').forEach((sort) => {
                    sort.remove();
                });
            }

            TCAIFilters.closeSelectedFilter(newSelectedFilter.querySelectorAll('.selected-filter-close'));

            listSelectedFilters.appendChild(newSelectedFilter);

            TCAIFilters.filter();
        });
    }
}

export default TCAISort;